// Utilitário para corrigir URLs de imagens
export const fixImageUrl = (imageUrl) => {
  if (!imageUrl) return null;
  
  // Se a URL já é absoluta e aponta para api.nostalbeat.com.br, retorna como está
  if (imageUrl.startsWith('https://api.nostalbeat.com.br/')) {
    return imageUrl;
  }
  
  // Se a URL é absoluta mas aponta para o domínio principal, corrige para o subdomínio da API
  if (imageUrl.startsWith('https://nostalbeat.com.br/')) {
    return imageUrl.replace('https://nostalbeat.com.br/', 'https://api.nostalbeat.com.br/');
  }
  
  // Se a URL é relativa, adiciona o domínio da API se em produção oficial, senão mantém relativo para Nginx
  if (imageUrl.startsWith('/uploads/')) {
    const hostname = window.location.hostname;
    if (hostname === 'nostalbeat.com.br' || hostname === 'www.nostalbeat.com.br') {
      return `https://api.nostalbeat.com.br${imageUrl}`;
    }
    return imageUrl;
  }
  
  // Se a URL é absoluta para localhost (desenvolvimento), normaliza para relativo ou produção
  if (imageUrl.startsWith('http://localhost:5000/')) {
    const hostname = window.location.hostname;
    if (hostname === 'nostalbeat.com.br' || hostname === 'www.nostalbeat.com.br') {
       return imageUrl.replace('http://localhost:5000', 'https://api.nostalbeat.com.br');
    }
    return imageUrl.replace('http://localhost:5000', '');
  }
  
  // Para outras URLs absolutas (como Facebook, etc.), retorna como está
  return imageUrl;
};

// Função para processar um objeto e corrigir todas as URLs de imagem
export const fixImageUrlsInObject = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;
  
  // Se é um array, processar cada item
  if (Array.isArray(obj)) {
    return obj.map(item => fixImageUrlsInObject(item));
  }
  
  const processed = { ...obj };
  
  // Campos que podem conter URLs de imagem
  const imageFields = [
    'profile_image',
    'banner_image', 
    'image_url',
    'imageUrl',
    'image',
    'banner',
    'photo',
    'bannerImage',
    'coverUrl',
    'djPhoto',
    'coverArt'
  ];
  
  imageFields.forEach(field => {
    if (processed[field]) {
      processed[field] = fixImageUrl(processed[field]);
    }
  });
  
  // Processar objetos aninhados
  Object.keys(processed).forEach(key => {
    if (typeof processed[key] === 'object' && processed[key] !== null) {
      processed[key] = fixImageUrlsInObject(processed[key]);
    }
  });
  
  return processed;
};
